import Page from 'views/page';
import Landing from 'views/landing';
import Takeaway from 'views/takeaway';
import Order from 'views/order';
import NotFound from 'views/not-found';

const routes = [
  {
    name: 'index',
    path: '/',
    component: Landing
  },
  {
    path: '/:location/takeaway',
    name: 'takeaway',
    component: Takeaway,
  },
  {
    path: '/:location/order',
    name: 'location-order',
    component: Order,
  },
  {
    path: '/:location/:uid',
    name: 'page',
    component: Page
  },
  {
    path: '/enskede',
    name: 'enskede-landing',
    component: Page,
    meta: { location: 'enskede', uid: 'enskede' }
  },
  {
    path: '/haga-norra',
    name: 'haga-norra-landing',
    component: Page,
    meta: { location: 'haga-norra', uid: 'haga-norra' }
  },
  {
    path: '/slaktis',
    name: 'slaktis-landing',
    component: Page,
    meta: { location: 'slaktis', uid: 'slaktis' }
  },
  {
    name: 'not-found',
    path: '/not-found',
    meta: { title: 'Page not found' },
    component: NotFound
  },
  {
    path: '*',
    redirect: { name: 'not-found' }
  }
];

export default routes;
